var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"app-dropdown-button-item",class:{ disabled: _vm.disabled }},[_c('a',{style:(_vm.textColor ? 'color: ' + _vm.textColor : ''),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }